const PERFORMANCE_ENTRY_ID = 'navigation',
  RELOAD_TYPE_MODERN = 'reload';

export { PERFORMANCE_ENTRY_ID, RELOAD_TYPE_MODERN };
